import useIsFCM from '../useIsFCM';
import useIsFeatureFlagEnabled from './useIsFeatureFlagEnabled';

const useDisableTcsTmeSync = () => useIsFeatureFlagEnabled('disableTcsTmeSync');

export const useAllowPostTradeRiskCFE = () => {
  const isFCM = useIsFCM();
  const tcsTmeSyncDisabled = useDisableTcsTmeSync();
  return isFCM && tcsTmeSyncDisabled;
};
export default useDisableTcsTmeSync;
